module.exports = __webpack_public_path__ + "static/img/authentication-icon.png";